"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refinementTypes = exports.loginTypes = exports.formTypes = exports.booleanTypes = void 0;
var booleanTypes = {
  YES: 'yes',
  NO: 'no'
};
exports.booleanTypes = booleanTypes;
var formTypes = {
  FORM: 'form',
  LEAD: 'lead'
};
exports.formTypes = formTypes;
var loginTypes = {
  API: 'api',
  BIOMETRIC: 'biometric',
  EMAIL: 'email',
  KEYCHAIN: 'keychain',
  MAGIC_LINK: 'magicLink',
  SSO: 'sso'
};
exports.loginTypes = loginTypes;
var refinementTypes = {
  CHANGED: 'changed_phrase',
  ORIGINAL: 'original_search'
};
exports.refinementTypes = refinementTypes;